import Vue from 'vue'
import Router from 'vue-router'
import Protocol from '@/components/Protocol.vue'
import ProtocolNew from '@/components/ProtocolNew.vue'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Protocol',
      component: ProtocolNew,
      keepAlive:false
    },
    {
      path: '/protocolnew',
      name: 'ProtocolNew',
      component: ProtocolNew,
      keepAlive:false
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js